/* eslint-disable default-case */
/* eslint-disable react/jsx-no-bind */
import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import { Auth, Hub } from 'aws-amplify';
import { Link, Button } from '@mui/material';

// layouts
import AuthLayout from '../layouts/AuthLayout';
// components

import { signOutStart } from '../redux/auth/auth.actions';
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

export default function Menu() {
  const [signedUser, setSignedUser] = useState(false);
  useEffect(() => {
    authListener();
  }, []);

  async function authListener() {
    Hub.listen('auth', (data) => {
      const { payload } = data;
      if (payload.event === 'signIn') {
        setSignedUser(true);
      }
      if (payload.event === 'signOut') {
        setSignedUser(false);
      }
    });

    try {
      await Auth.currentAuthenticatedUser();
      setSignedUser(true);
    } catch (err) {
      setSignedUser(false);
    }
  }

  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function handleSignOut() {
    try {
      await dispatch(signOutStart());
      navigate('/', { replace: true });
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <AuthLayout>
      {signedUser ? (
        <>
          <Link underline="none" variant="subtitle2" component={RouterLink} to="/client-dashboard">
            <Button color="secondary" variant="outlined">
              Mes plaintes
            </Button>
          </Link>
          &nbsp;
          {/* <Link underline="none" variant="subtitle2" component={RouterLink} to="/login-password-change">
            <Button color="secondary" variant="outlined">
              Changer de mot de passe
            </Button>
          </Link>
          &nbsp; */}
          <Button color="secondary" variant="outlined" onClick={handleSignOut}>
            Déconnexion
          </Button>
        </>
      ) : (
        <>
          {' '}
          <Link underline="none" variant="subtitle2" component={RouterLink} to="/search">
            <Button color="secondary" variant="outlined">
              Rechercher une plainte
            </Button>
          </Link>{' '}
          &nbsp;
          <Link underline="none" variant="subtitle2" component={RouterLink} to="/login">
            <Button color="secondary" variant="outlined">
              S'authentifier
            </Button>
          </Link>
        </>
      )}
    </AuthLayout>
  );
}
